import { apiClient } from "@/api/modules/base.ts";
import { Route } from "@/api/modules/autoQ/mailSenders/route.ts";
import type { AxiosPromise } from "axios";
import type {
    MailSenderListResponse
} from "@/api/modules/autoQ/mailSenders/types.ts";

export const list = (): AxiosPromise<MailSenderListResponse> =>
    apiClient.get(Route.MailSenders);